// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_gG5","cls2":"PaperImages-cls2_Zzl PaperImages-cls1_gG5"};